export interface InvestidorParsedData {
  id: string; // Required by MUI DataGrid
  cpfCnpj: string;
  razaoSocial: string;
  email: string;
  nacionalidade: string;
  telefones: string;
  politicamenteExposto: string;
  dataNascimento: string;
  rendaMensalDeclarada: string;
  patrimonioDeclarado: string;
  atividadePrincipal: string;
  cnpjCustodiante: string;
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  numero: string;
  valido?: boolean;
  mensagemErro?: string;
}

export interface InvestidorEmLoteProps {
  fileId?: string;
  disabled?: boolean;
  disableRemove?: boolean;
  inputAttachments?: Attachment[];
  onChange?(attachments: Attachment[]): void;
  onDelete?(id: string): void;
  onError?(error: any): void;
  multipleFiles?: boolean;
  aditamento?: boolean;
  overrideAcceptableFileTypes?: Array<AcceptableFileTypes>;
}

export interface Attachment {
  id: string;
  file?: File;
  remoteFileInfo?: any;
}

export enum AcceptableFileTypes {
  ImageJpeg = 'image/jpeg',
  ImagePng = 'image/png',
  AppWord = 'application/msword',
  AppWordGeneric = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  AppExcel = 'application/vnd.ms-excel',
  AppExcelGeneric = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  AppPdf = 'application/pdf',
  Txt = 'text/plain',
  Zip = 'application/zip',
  XZipCompressed = 'application/x-zip-compressed',
  Html = 'text/html',
  Email = 'message/rfc822',
  Csv = 'text/csv',
}

export const defaultAcceptableFileTypes = [
  AcceptableFileTypes.ImageJpeg,
  AcceptableFileTypes.ImagePng,
  AcceptableFileTypes.AppWord,
  AcceptableFileTypes.AppWordGeneric,
  AcceptableFileTypes.AppExcel,
  AcceptableFileTypes.AppExcelGeneric,
  AcceptableFileTypes.AppPdf,
  AcceptableFileTypes.Txt,
  AcceptableFileTypes.Zip,
  AcceptableFileTypes.XZipCompressed,
  AcceptableFileTypes.Html,
  AcceptableFileTypes.Email,
  AcceptableFileTypes.Csv,
];
